import { MasterImport } from './Import'
const { RoutesMap, CountryList, StateList, CityList, DepartmentList, DesignationList, LocationList, ComponentList, MakeList, EquipmentList, EquipmentAssignList, ObjectConditionList, ObjectList } = MasterImport

const MasterRoute = () => {
    return [
        {
            path: RoutesMap.COUNTRY_LIST.path,
            element: <CountryList />
        },

        {
            path: RoutesMap.STATE_LIST.path,
            element: <StateList />
        },

        {
            path: RoutesMap.CITY_LIST.path,
            element: <CityList />
        },

        {
            path: RoutesMap.DEPARTMENT_LIST.path,
            element: <DepartmentList />
        },

        {
            path: RoutesMap.DESIGNATION_LIST.path,
            element: <DesignationList />
        },

        {
            path: RoutesMap.LOCATION_LIST.path,
            element: <LocationList />
        },

        {
            path: RoutesMap.COMPONENT_LIST.path,
            element: <ComponentList />
        },

        {
            path: RoutesMap.MAKE_LIST.path,
            element: <MakeList />
        },

        {
            path: RoutesMap.EQUIPMENT_LIST.path,
            element: <EquipmentList />
        },

        {
            path: RoutesMap.EQUIPMENT_ASSIGN_LIST.path,
            element: <EquipmentAssignList />
        },

        {
            path: RoutesMap.OBJECT_CONDITION_LIST.path,
            element: <ObjectConditionList />
        },

        {
            path: RoutesMap.OBJECT_LIST.path,
            element: <ObjectList />
        },
    ]
}

export default MasterRoute;